import { render } from "./TrainingSectionInfoBlockItem.vue?vue&type=template&id=7047928d&scoped=true"
import script from "./TrainingSectionInfoBlockItem.vue?vue&type=script&lang=js"
export * from "./TrainingSectionInfoBlockItem.vue?vue&type=script&lang=js"

import "./TrainingSectionInfoBlockItem.vue?vue&type=style&index=0&id=7047928d&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7047928d"]])

export default __exports__